module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "campus-submission"
  }, [_c('dam-submission', {
    attrs: {
      "type": 'campusSubmission'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-442a1996!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CampusSubmission.vue
// module id = 2037
// module chunks = 2